import styled from 'styled-components';

export default styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .custom-tooltip {
    min-width: 230px;
    padding: var(--size) 12px;

    .label {
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 12px;
      color: #001529;
    }

    .value {
      display: flex;

      label {
        margin-bottom: 0px;
        font-size: 12px;
      }

      .title {
        font-weight: 500;
        width: 140px;
      }

      .percentage {
        color: var(--color-primary-70);
        font-weight: 700;
      }
    }
  }
`;
